import * as ng from 'angular';
import * as _ from 'underscore';
import * as uib from 'angular-ui-bootstrap';

import { Experience, ExperienceTypeDef } from '../../';
import { EditorModel } from '../../editor/editor.model';
import { EditorPageModel } from '../../editor/editor-page.model';
import { L10nService } from '../../../../shared';

const smsMessageModalUrl = require('./sms-message-modal.html');

ng.module('e360')
   .factory('smsEditorModelFactory', smsEditorModelFactory);

smsEditorModelFactory.$inject = ['instanceServiceFactory'];
function smsEditorModelFactory(instanceServiceFactory) {
   return instanceServiceFactory(SMSEditorModel);
}

export interface SMSEditorModelFactory {
   ({campaign, typeDef:ExperienceTypeDef, experience:Experience}):SMSEditorModel
}

export class SMSEditorModel extends EditorModel {
   readonly workspaceClass: string;
   readonly pages: SMSPageModel[];

   static $inject = ['$uibModal', 'l10n', 'gettextCatalog']
      .concat(['campaign', 'typeDef', 'experience']);

   constructor(
      private $uibModal:uib.IModalService,
      private l10n:L10nService,
      private gettextCatalog,
      campaign, typeDef: ExperienceTypeDef, experience: Experience
   ) {
      super(campaign, typeDef, experience);

      this.gettextCatalog.getString("Thanks for joining us! Here's your photo: {url}");

      this.workspaceClass = 'device sms';

      let defaults = {
         uploads: {}
      };

      if (this.isNew) {
         this.experience = {
            campaignId: campaign.id,
            type: typeDef.id,
            settings: ng.copy(defaults)
         };
      }

      this.l10n.translateObject(
         this.experience.settings,
         'message',
         "Thanks for joining us! Here's your photo: {url}",
         this.languages
      );

      this.pages = [new SMSPageModel(this)];
   }

   editMessage():void {
      this.$uibModal.open({
         size: 'md',
         backdrop: 'static',
         templateUrl: smsMessageModalUrl,
         controller: 'SMSMessageController as ctl',
         resolve: {
            message: () => this.experience.settings.message[this.language]
         }
      }).result.then((message) => {
         this.experience.settings.message[this.language] = message;
      });
   }
}

const smsView = require('./sms-editor.html');

class SMSPageModel extends EditorPageModel {
   constructor(editor: SMSEditorModel) {
      super(editor);
   }

   get settings() {
      return this.editor.settings;
   }

   get view() {
      return smsView;
   }
}
